import React, { Component } from 'react';

import renderHTML from 'react-render-html';
import PropTypes from 'prop-types';

import { AddFavorite, StorageHandler, Diploma, SharingPopup } from 'C4';
import { storageKeys } from 'settings';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { renderToString } from 'react-dom/server';

const SpotifyPlayer = (props) => {
  const { links, width } = props;
  const parsedElements = [];

  links.forEach((link, i) => {
    const key = `${link}_${i}`;
    if (link.url.length > 0 && link.url.includes('spotify')) {
      parsedElements.push(<iframe
        key={key}
        title={link.url}
        src={link.url}
        height="500px"
        width={width}
      />);
    }
  });

  return parsedElements;
};

export default class TrainingText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
      firstName: '',
      lastName: '',
      diploma: false,
    };
  }

  componentDidMount() {
    const { appId, pageType, upID } = this.props;
    let { text } = this.props;
    this.getAppInfo();
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      if (pageType !== 'Final-Page') {
        const anaUri = `https://crm.travpromobile.com/api/uri?email=${email}&app_id=${appId}&url=`;
        text = text.replace('href="', `href="${anaUri}`);
        text = text.replace(/href="/g, (i => m => !i++ ? m : `href="${anaUri}`)(0));
        text = text.split('<a').join('<a target="_blank"');
      }
      this.setState({ text });

      // const weblinks = text.getElementsByTagName('a');
      // for (let i = 0, len = weblinks.length; i < len; i++) {
      //   weblinks[i].target = '_blank';
      // }
    });

    this.props.contentComplete();
  }

  async getAppInfo() {
    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      this.setState({
        firstName: user.first_name,
        lastName: user.last_name,
      });
    }
  }


  render() {
    const {
      appId,
      buttons,
      links,
      pageID,
      pageType,
      subtitle,
      title,
      type,
      upID,
      hideTitle,
    } = this.props;

    const { text, diploma, firstName, lastName } = this.state;
    let chapterId = 0;
    const index = upID.indexOf("P");
    if (index !== -1) {
      chapterId = upID.substring(0, index);
    }

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'y',
      },
      buttons: ['share', 'close'],
      share: {
        tpl: renderToString(<SharingPopup url={`https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=chapter-${chapterId}`} />),
      },
    };

    return (
      <div
        className={`text__container ${pageType === 'Final-Page' ? 'wideFinalPage' : undefined}`}
        key={upID}
      >
        {/* <div className="text__container" key={upID}> */}
        {buttons}
        {((pageType === 'Final-Page') || (pageType === 'Introduction')) &&
          <div className="image" />
        }
        {!hideTitle && <h3 className={`pageTitle ${pageType === 'Final-Page' && 'finalPageTitle'}`} dangerouslySetInnerHTML={{ __html: title }} />}
        <h4>{subtitle}</h4>
        {type === 'Spotify' && (
          <SpotifyPlayer
            links={links}
            width="100%"
          />
        )}
        <div className="bodyContent">
          {renderHTML((
            text
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/allowTransparency="[a-zA-Z0-9:;.s()\-,]*"/gi, '')
              .replace(/allowfullscreen/gi, 'allowFullScreen="allowFullScreen"')
            ))
          }
        </div>

        {pageType === 'Final-Page' && (chapterId === '3752' || chapterId === '3761' || chapterId === '3758' || chapterId === '3760') &&
        <div className="trophy">
          <a
            className="trophy__button"
            href={`https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=chapter-${chapterId}`}
            data-fancybox={`https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=chapter-${chapterId}`}
            data-options={JSON.stringify(fancyOptions)}
            data-caption=""
          >
            <FontAwesomeIcon icon={['fas', 'trophy']} />
            <span dangerouslySetInnerHTML={{__html: i18n.translate('general.badge')}} />
          </a>
        </div>
        }

        {pageType !== 'Final-Page' &&
        <AddFavorite
          appId={appId}
          viewType="p"
          upID={upID}
          pageID={pageID}
          bgEnabled
          centered
        />}
      </div>
    );
  }
}

TrainingText.propTypes = {
  buttons: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.element,
  ]),
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func,
  hideTitle: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.object),
  pageID: PropTypes.string,
  pageType: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  upID: PropTypes.string.isRequired,
};

TrainingText.defaultProps = {
  buttons: [],
  contentComplete: () => {},
  hideTitle: false,
  links: [],
  pageID: '',
  subtitle: '',
  text: '',
  title: '',
  type: '',
};
